var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { BreadCrumb, Button, Tag, Typography } from "@uigovpe/components";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useMemo, useState } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { getApiErrorMessage } from "../../../apis/http";
import { getHearingAttachments, getHearingById, } from "../../../apis/hearings";
import { getHearingItems, getMyHearingContribution, } from "../../../apis/hearingParticipation";
import { ConsultationFileButton, readFileSizeFromMetadata, } from "../../consultations/components/ConsultationFileButton";
import { SectionDivider } from "../../consultations/components/SectionDivider";
import { capitalizeSentence, formatDateTime, truncateText, } from "../../consultations/utils/formatters";
import { normalizePublicFileUrl } from "../../consultations/utils/publicFileUrl";
import { useAuth } from "../../auth/AuthContext";
import { HearingCommentsSection } from "../components/HearingCommentsSection";
import { HearingContributionPreview } from "../components/HearingContributionPreview";
import { VideoCallButton } from "../components/VideoCallButton";
import { canAccessRecording, canAccessVideoCall, formatHearingAddress, getHearingStatusDisplay, hearingTypeLabels, } from "../utils/status";
import { openExternalUrlSafely } from "../utils/url";
var pageStyle = {
    display: "grid",
    gap: 16,
    padding: "16px 12px 32px",
    width: "100%",
};
var topGridStyle = {
    alignItems: "start",
    display: "grid",
    gap: 24,
};
var summaryStyle = {
    display: "grid",
    gap: 16,
};
var detailsCardStyle = {
    border: "1px solid #E5E7EB",
    borderRadius: 8,
    display: "grid",
    gap: 8,
    padding: 16,
};
var contentBlockStyle = {
    display: "grid",
    gap: 16,
};
var feedbackBoxBaseStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var inlineLinkStyle = {
    alignItems: "center",
    color: "#1451B4",
    display: "inline-flex",
    gap: 4,
    textDecoration: "none",
};
export var HearingDetailsPage = function () {
    var _a, _b;
    var slug = useParams().slug;
    var hearingId = Number(slug);
    var hasValidHearingId = Number.isFinite(hearingId) && hearingId > 0;
    var isDesktop = useMediaQuery("(min-width: 960px)");
    var navigate = useNavigate();
    var accessToken = useAuth().accessToken;
    var _c = useState([]), attachments = _c[0], setAttachments = _c[1];
    var _d = useState(null), hearing = _d[0], setHearing = _d[1];
    var _e = useState([]), items = _e[0], setItems = _e[1];
    var _f = useState(false), hasAnswered = _f[0], setHasAnswered = _f[1];
    var _g = useState(false), loadingContribution = _g[0], setLoadingContribution = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(null), pageError = _j[0], setPageError = _j[1];
    useEffect(function () {
        if (!hasValidHearingId) {
            setPageError("Audiência inválida.");
            setLoading(false);
            return;
        }
        var isMounted = true;
        var loadPage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, hearingResponse, attachmentsResponse, publicHearing, itemsResponse, _b, error_1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 9, 10, 11]);
                        return [4 /*yield*/, Promise.all([
                                getHearingById(hearingId),
                                getHearingAttachments(hearingId),
                            ])];
                    case 2:
                        _a = _d.sent(), hearingResponse = _a[0], attachmentsResponse = _a[1];
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        publicHearing = hearingResponse.data.publicHearing;
                        setHearing(publicHearing);
                        setAttachments(((_c = attachmentsResponse.data.attachments) === null || _c === void 0 ? void 0 : _c.length)
                            ? attachmentsResponse.data.attachments
                            : publicHearing.attachments || []);
                        if (!(publicHearing.contributionType === "with_form")) return [3 /*break*/, 7];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, getHearingItems(hearingId)];
                    case 4:
                        itemsResponse = _d.sent();
                        if (isMounted) {
                            setItems(itemsResponse.data.items || []);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        _b = _d.sent();
                        if (isMounted) {
                            setItems([]);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (isMounted) {
                            setItems([]);
                        }
                        _d.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        error_1 = _d.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setPageError(getApiErrorMessage(error_1));
                        return [3 /*break*/, 11];
                    case 10:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        }); };
        void loadPage();
        return function () {
            isMounted = false;
        };
    }, [hasValidHearingId, hearingId]);
    useEffect(function () {
        if (!accessToken || !hasValidHearingId) {
            setHasAnswered(false);
            return;
        }
        var isMounted = true;
        var loadContribution = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoadingContribution(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getMyHearingContribution(hearingId, accessToken)];
                    case 2:
                        response = _b.sent();
                        if (isMounted) {
                            setHasAnswered(Boolean(response.data.contribution));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        if (isMounted) {
                            setHasAnswered(false);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoadingContribution(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadContribution();
        return function () {
            isMounted = false;
        };
    }, [accessToken, hasValidHearingId, hearingId]);
    var editalAttachment = attachments.find(function (attachment) { return attachment.category === "edital"; });
    var minutesAttachment = attachments.find(function (attachment) { return attachment.category === "minutes"; });
    var extraAttachments = attachments.filter(function (attachment) {
        return attachment.category !== "edital" && attachment.category !== "minutes";
    });
    var showAddress = useMemo(function () {
        return hearing && (hearing.type === "in_person" || hearing.type === "hybrid");
    }, [hearing]);
    var showVideoCall = useMemo(function () {
        var _a;
        return Boolean(hearing &&
            canAccessVideoCall(hearing.status) &&
            (hearing.type === "online" || hearing.type === "hybrid") &&
            ((_a = hearing.videoCallLink) === null || _a === void 0 ? void 0 : _a.trim()));
    }, [hearing]);
    var showRecording = useMemo(function () { return Boolean(hearing && canAccessRecording(hearing)); }, [hearing]);
    var statusDisplay = useMemo(function () { return (hearing ? getHearingStatusDisplay(hearing) : null); }, [hearing]);
    var showContributionSection = hearing &&
        hearing.contributionType !== "without_contribution" &&
        hearing.status !== "canceled";
    var showCommentsSection = hearing && hearing.status !== "canceled";
    var handleOpenAttachment = function (attachment) {
        openExternalUrlSafely(normalizePublicFileUrl(attachment.path));
    };
    return (_jsxs("div", __assign({ style: pageStyle }, { children: [_jsx(BreadCrumb, { home: { icon: "pi pi-home", url: "/" }, model: [
                    { label: "Início", url: "/" },
                    {
                        label: hearing
                            ? capitalizeSentence(hearing.title)
                            : "Detalhes da audiência",
                    },
                ] }), loading ? (_jsx(Typography, { children: "Carregando..." })) : pageError || !hearing ? (_jsxs("div", __assign({ style: contentBlockStyle }, { children: [_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxBaseStyle), { background: "#FFE4E4", color: "#7A1F1F" }) }, { children: _jsx(Typography, { children: pageError || "Audiência não encontrada." }) })), _jsx("div", { children: _jsx(Button, { label: "Voltar para o in\u00EDcio", onClick: function () { return navigate("/"); } }) })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: __assign(__assign({}, topGridStyle), { gridTemplateColumns: isDesktop
                                ? "minmax(0, 1.2fr) minmax(380px, 480px)"
                                : "1fr" }) }, { children: [_jsxs("div", __assign({ style: summaryStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: hearing.title })), _jsx("div", __assign({ style: contentBlockStyle }, { children: _jsx(Typography, { children: hearing.description }) })), showVideoCall ? (_jsx(VideoCallButton, { label: "Assistir ao vivo", url: hearing.videoCallLink })) : null, showRecording ? (_jsx(VideoCallButton, { label: "Assistir grava\u00E7\u00E3o", url: hearing.recordingLink })) : null] })), _jsxs("div", __assign({ style: detailsCardStyle }, { children: [_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Detalhes" })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "\u00D3rg\u00E3o:" }), " ", capitalizeSentence(((_a = hearing.agency) === null || _a === void 0 ? void 0 : _a.name) || "—")] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Tema:" }), " ", capitalizeSentence(truncateText(((_b = hearing.theme) === null || _b === void 0 ? void 0 : _b.name) || "—", 30))] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Tipo:" }), " ", hearingTypeLabels[hearing.type]] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Data e hora:" }), " ", formatDateTime(hearing.startDate)] })), showAddress ? (_jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Endere\u00E7o:" }), " ", formatHearingAddress(hearing)] }))) : null, hearing.consultation ? (_jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Consulta associada:" }), " ", _jsxs(RouterLink, __assign({ rel: "noopener noreferrer", style: inlineLinkStyle, target: "_blank", to: "/details/".concat(hearing.consultation.id) }, { children: ["Acessar", _jsx(OpenInNewRoundedIcon, { style: { fontSize: 16 } })] }))] }))) : null, statusDisplay ? (_jsxs("div", __assign({ style: { alignItems: "center", display: "flex", gap: 8 } }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: _jsx("strong", { children: "Situa\u00E7\u00E3o:" }) })), _jsx(Tag, { severity: statusDisplay.severity, value: statusDisplay.label })] }))) : null, editalAttachment ? (_jsxs("div", __assign({ style: { display: "grid", gap: 8, paddingTop: 8 } }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: _jsx("strong", { children: "Edital:" }) })), _jsx(ConsultationFileButton, { fileName: editalAttachment.fileName || "", fileSizeBytes: readFileSizeFromMetadata(editalAttachment.metadata), onOpen: function () { return handleOpenAttachment(editalAttachment); } })] }))) : null, minutesAttachment ? (_jsxs("div", __assign({ style: { display: "grid", gap: 8, paddingTop: 8 } }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: _jsx("strong", { children: "Ata:" }) })), _jsx(ConsultationFileButton, { fileName: minutesAttachment.fileName || "", fileSizeBytes: readFileSizeFromMetadata(minutesAttachment.metadata), onOpen: function () { return handleOpenAttachment(minutesAttachment); } })] }))) : null] }))] })), _jsx(SectionDivider, { children: "Anexos" }), extraAttachments.length > 0 ? (_jsx("div", __assign({ style: { display: "grid", gap: 12, maxWidth: 480 } }, { children: extraAttachments.map(function (attachment) { return (_jsx(ConsultationFileButton, { fileName: attachment.fileName || "", fileSizeBytes: readFileSizeFromMetadata(attachment.metadata), onOpen: function () { return handleOpenAttachment(attachment); } }, attachment.id)); }) }))) : (_jsx(Typography, __assign({ size: "sm" }, { children: "Nenhum anexo enviado ainda." }))), showContributionSection ? (_jsxs(_Fragment, { children: [_jsx(SectionDivider, { children: "Contribui\u00E7\u00E3o" }), _jsx(HearingContributionPreview, { contributionType: hearing.contributionType, hasAnswered: hasAnswered, hearingId: hearing.id, hearingStatus: hearing.status, items: items, loadingContribution: loadingContribution, openPrompt: hearing.description })] })) : null, showCommentsSection ? (_jsxs(_Fragment, { children: [_jsx(SectionDivider, { children: "Coment\u00E1rios" }), _jsx(HearingCommentsSection, { hearingId: hearing.id, hearingStatus: hearing.status })] })) : null] }))] })));
};
